import { render, staticRenderFns } from "./PublicSea.vue?vue&type=template&id=d3970a18&scoped=true"
import script from "./PublicSea.vue?vue&type=script&lang=js"
export * from "./PublicSea.vue?vue&type=script&lang=js"
import style0 from "./PublicSea.vue?vue&type=style&index=0&id=d3970a18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3970a18",
  null
  
)

export default component.exports